module.exports = __webpack_public_path__ + "static/media/marcass.9e795d88.jpg";